import { Helmet } from 'react-helmet-async';

/**
 * SEO component for managing page-specific meta tags
 * @param {Object} props
 * @param {string} props.title - Page title (will be appended with " | Tom McKay")
 * @param {string} props.description - Page meta description
 * @param {string} [props.image] - OG image URL (optional)
 * @param {string} [props.type] - OG type (default: 'website')
 * @param {string} [props.path] - URL path for canonical (optional)
 */
const SEO = ({ title, description, image, type = 'website', path }) => {
    const siteUrl = 'https://flipanythingusa.com';
    const fullTitle = title ? `${title} | Tom McKay` : 'Tom McKay | Real Estate Investing & Mentorship';
    const fullUrl = path ? `${siteUrl}${path}` : siteUrl;
    const ogImage = image || `${siteUrl}/og-image.png`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={fullUrl} />

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={ogImage} />
        </Helmet>
    );
};

export default SEO;
